// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2HLIV","productName":"Table_productName__29RqE"};